// extracted by mini-css-extract-plugin
export default {"container":"InputSearch_container__tduFU","form":"InputSearch_form__BPLU7","input":"InputSearch_input__B3oqb","btn":"InputSearch_btn__vswp2"};